import * as angular from 'angular';
import { ClassificationCategoryListItem } from '../../../app.retailer/modules/core';
import { IChoiceCategoriesTreeOptions } from '../categories/select-classification-categories-tree/select-classification-categories-tree.component';

export class RetailerCommonPopupService {
    public static $inject = ['$uibModal'];

    constructor(private $uibModal: ng.ui.bootstrap.IModalService) { }

    public categoriesSelector(excludedIDs: number[], selectedIDs: number[], showPrices: boolean, leafOnly: boolean, singleSelect: boolean, languageId: number): angular.IPromise<ClassificationCategoryListItem[]> {
        return this.$uibModal.open({
            component: 'selectClassificationCategoriesTree',
            size: 'md',
            windowClass: 'categories-selector-popup',
            resolve: {
                options: (): IChoiceCategoriesTreeOptions => {
                    return {
                        showPrices,
                        excludedIDs,
                        selectedIDs,
                        leafOnly,
                        singleSelect,
                        recentlyUsedCategories: []
                    };
                },
                languageId: (): number => {
                    return languageId;
                }
            }
        }).result;
    }
}

angular.module('app.retailes.common').service('retailerCommonPopupService', RetailerCommonPopupService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer.common/modules/popup/retailer-common-popup.service.ts